import { useState } from 'react';

const faqs = [
  {
    question: '男同网是免费的吗？如何使用交友功能？',
    answer: '是的，男同网的所有基础功能完全免费。你可以浏览文章、参与社群讨论、查看活动资讯。交友功能通过社群互动和活动参与自然展开——在真实的交流中认识志同道合的朋友，比纯粹的约会应用更有温度和深度。',
  },
  {
    question: '平台如何保护我的隐私和安全？',
    answer: '你的隐私安全是我们的首要考量。所有个人信息均采用加密存储，你可以自主选择公开或隐藏个人资料。我们建立了严格的社区规范，绝不容忍任何形式的骚扰、歧视或隐私侵犯行为。',
  },
  {
    question: '男同网的文章内容可靠吗？',
    answer: '我们的内容团队由专业人士和社群达人组成。健康指南类内容经过医疗专业人士审核，生活资讯来自经验丰富的撰稿人。我们坚持原创、真实、有价值的创作原则，为男同群体提供可信赖的资讯服务。',
  },
  {
    question: '如何参与线下活动？',
    answer: '在"活动资讯"频道可以查看全国各地的最新活动。每场活动都有详细的报名方式和参与须知。你还可以关注你所在城市的社群动态，及时获取第一手活动信息。我们鼓励大家走出家门，在安全友好的环境中结识新朋友。',
  },
  {
    question: '我可以投稿吗？如何成为平台的创作者？',
    answer: '非常欢迎！我们一直期待更多社群成员分享自己的故事和见解。你可以通过"关于我们"页面的联系表单提交稿件，或者发送至官方邮箱。编辑团队会在3个工作日内审核并回复。优秀创作者将获得平台推荐和专属权益。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于男同网的常见疑问，这里都有答案
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}